import { CompletionStatuses } from '../../../constants';
import { GathererKeys } from '../../../gatherers/allGatherers';
export const addH1TagsAudit = artifacts => {
  const pageTitle = artifacts[GathererKeys.PAGE_TITLE];
  const postBody = artifacts[GathererKeys.POST_BODY];
  const h1Elements = artifacts[GathererKeys.H1_ELEMENTS];
  const allModules = artifacts[GathererKeys.ALL_MODULES];
  let status;
  if (h1Elements) {
    status = CompletionStatuses.COMPLETE;
  } else {
    status = CompletionStatuses.INCOMPLETE;
  }
  return {
    status,
    h1Elements,
    pageTitle,
    postBody,
    allModules: !allModules ? null : allModules.toJS()
  };
};